var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001Wohnung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 514,
    height: 514,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 164.002,
    y: 47.452,
    width: 182.151,
    height: 398.297,
    id: "svg_38",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 348.639,
    y: 131.964,
    width: 107.234,
    height: 334.275,
    id: "svg_39",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 53.313,
    y: 132.911,
    width: 110.127,
    height: 333.329,
    id: "svg_40",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 54.576,
    y: 333.162,
    width: 48.458,
    height: 80.093,
    id: "svg_54",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 151.164,
    y: 442.966,
    width: 206.673,
    height: 23.274,
    id: "svg_3",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.26639,439.26701l-198.72793,0c-3.91745,0 -7.09716,3.20113 -7.09716,7.14497l0,14.29077c0,3.94384 3.17971,7.14497 7.09716,7.14497s7.09716,-3.20113 7.09716,-7.14497l0,-7.14497l191.63077,0c3.91745,0 7.09716,-3.20112 7.09716,-7.14496s-3.17888,-7.14581 -7.09716,-7.14581z",
    id: "svg_4",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1895ff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 207.904,
    y: 177.345,
    width: 23.867,
    height: 37.862,
    id: "svg_42",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 209.818,
    y: 177.16,
    width: 23.867,
    height: 37.862,
    id: "svg_22",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.22024,217.76383c0,3.94384 3.1797,7.14497 7.09715,7.14497l28.3903,0c3.91746,0 7.09716,-3.20113 7.09716,-7.14497l0,-42.87147c0,-3.94384 -3.1797,-7.14497 -7.09716,-7.14497l-28.38946,0c-3.91746,0 -7.09716,3.20113 -7.09716,7.14497l0,42.87147l-0.00083,0zm14.19514,-35.72567l14.19515,0l0,28.58071l-14.19515,0l0,-28.58071z",
    id: "svg_5",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 94.354,
    y: 177.16,
    width: 23.867,
    height: 37.862,
    id: "svg_9",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.34331,124.87592l-85.16923,0c-3.91745,0 -7.09716,3.20112 -7.09716,7.14496l0,142.9052c0,3.94384 3.17971,7.14497 7.09716,7.14497s7.09716,-3.20113 7.09716,-7.14497l0,-135.75939l78.07207,0c3.91745,0 7.09716,-3.20113 7.09716,-7.14497s-3.17888,-7.1458 -7.09716,-7.1458z",
    id: "svg_6",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 394.502,
    y: 349.181,
    width: 23.867,
    height: 37.862,
    id: "svg_49",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.75385,389.24973c0,3.94385 3.17971,7.14497 7.09716,7.14497l28.38946,0c3.91746,0 7.09716,-3.20112 7.09716,-7.14497l0,-42.87147c0,-3.94384 -3.1797,-7.14497 -7.09716,-7.14497l-28.38946,0c-3.91746,0 -7.09716,3.20113 -7.09716,7.14497l0,42.87147zm14.19515,-35.72567l14.19515,0l0,28.58071l-14.19515,0l0,-28.58071z",
    id: "svg_7",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 63.978,
    y: 307.678,
    width: 29.653,
    height: 50.24,
    id: "svg_55",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 54.562,
    y: 324.268,
    width: 20.605,
    height: 85.804,
    id: "svg_27",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 81.308,
    y: 324.925,
    width: 20.605,
    height: 85.804,
    id: "svg_26",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 66.304,
    y: 309.163,
    width: 23.867,
    height: 102.879,
    id: "svg_25",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.56438,296.36182c-35.08324,0 -35.48746,91.95931 -35.48746,92.88791c0,17.25577 12.2148,31.68219 28.38947,35.00473l0,36.44829c0,3.94384 3.1797,7.14497 7.09716,7.14497c3.91745,0 7.09716,-3.20113 7.09716,-7.14497l0,-36.44829c16.17466,-3.32254 28.38946,-17.74896 28.38946,-35.00473c0.00083,-0.9286 -0.40339,-92.88791 -35.48579,-92.88791zm0,114.32365c-11.73905,0 -21.29231,-9.61761 -21.29231,-21.43574c0,-35.59756 9.4967,-78.59798 21.29231,-78.59798c11.7956,0 21.2923,43.00042 21.2923,78.59798c0,11.81813 -9.55325,21.43574 -21.2923,21.43574z",
    id: "svg_8",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1895ff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 393.779,
    y: 177.345,
    width: 23.867,
    height: 37.862,
    id: "svg_45",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 393.777,
    y: 176.503,
    width: 23.867,
    height: 37.862,
    id: "svg_24",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.85101,224.90964l28.38946,0c3.91746,0 7.09716,-3.20113 7.09716,-7.14497l0,-42.87148c0,-3.94384 -3.1797,-7.14496 -7.09716,-7.14496l-28.38946,0c-3.91746,0 -7.09716,3.20112 -7.09716,7.14496l0,42.87148c0,3.94384 3.17971,7.14497 7.09716,7.14497zm7.09799,-42.87148l14.19515,0l0,28.58071l-14.19515,0l0,-28.58071z",
    id: "svg_10",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.14899,167.74739l-28.3903,0c-3.91745,0 -7.09715,3.20113 -7.09715,7.14497l0,42.87147c0,3.94384 3.1797,7.14497 7.09715,7.14497l28.38947,0c3.91745,0 7.09716,-3.20113 7.09716,-7.14497l0,-42.87147c0.00083,-3.94384 -3.17888,-7.14497 -7.09633,-7.14497zm-7.09799,42.87148l-14.19432,0l0,-28.58071l14.19515,0l0,28.58071l-0.00083,0z",
    id: "svg_11",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1895ff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 280.229,
    y: 176.617,
    width: 23.867,
    height: 37.862,
    id: "svg_44",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 278.314,
    y: 175.19,
    width: 23.867,
    height: 37.862,
    id: "svg_23",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.19515,217.76383c0,3.94384 3.17971,7.14497 7.09716,7.14497l28.38947,0c3.91745,0 7.09715,-3.20113 7.09715,-7.14497l0,-42.87147c0,-3.94384 -3.1797,-7.14497 -7.09715,-7.14497l-28.38947,0c-3.91745,0 -7.09716,3.20113 -7.09716,7.14497l0,42.87147zm14.19432,-35.72567l14.19515,0l0,28.58071l-14.19515,0l0,-28.58071z",
    id: "svg_12",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 390.886,
    y: 262.535,
    width: 23.867,
    height: 37.862,
    id: "svg_48",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 407.49,
    y: 418.538,
    width: 25.626,
    height: 26.898,
    id: "svg_2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 380.092,
    y: 430.359,
    width: 76.508,
    height: 26.898,
    id: "svg_1",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.82592,124.87592l-85.16923,0c-3.91745,0 -7.09716,3.20112 -7.09716,7.14496s3.17971,7.14497 7.09716,7.14497l78.07207,0l0,287.12501c-2.2282,-0.80049 -4.59198,-1.31462 -7.09716,-1.31462c-1.22763,0 -2.44861,0.10718 -3.64797,0.32154c-4.89723,-8.8816 -14.21594,-14.61231 -24.74149,-14.61231c-10.52556,0 -19.84427,5.73071 -24.7415,14.61231c-1.19935,-0.21436 -2.42034,-0.32154 -3.64797,-0.32154c-11.73905,0 -21.29231,9.61762 -21.29231,21.43574s9.55326,21.43574 21.29231,21.43574l56.7781,0c11.73905,0 21.29231,-9.61761 21.29231,-21.43574l0,-314.3911c0,-3.94384 -3.17971,-7.14496 -7.09716,-7.14496zm-14.19515,328.68103l-56.77976,0c-3.9108,0 -7.09716,-3.20783 -7.09716,-7.14497s3.18636,-7.14497 7.09716,-7.14497c1.36237,0 2.65405,0.39271 3.84675,1.16473c1.94459,1.25768 4.37241,1.48627 6.51578,0.61461c2.14337,-0.87167 3.72616,-2.74394 4.24432,-5.00893c1.49795,-6.50943 7.16869,-11.06118 13.78345,-11.06118c6.61475,0 12.28549,4.55175 13.78344,11.06118c0.51817,2.26499 2.10095,4.13726 4.24432,5.00893c2.13672,0.87166 4.57036,0.64307 6.51578,-0.61461c4.62026,-3.001 10.94391,0.67155 10.94391,5.98024c-0.00083,3.93714 -3.18719,7.14497 -7.09799,7.14497z",
    id: "svg_13",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 279.506,
    y: 89.971,
    width: 23.867,
    height: 37.862,
    id: "svg_51",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.29231,139.16669l28.38947,0c3.91745,0 7.09715,-3.20113 7.09715,-7.14497l0,-42.87148c0,-3.94384 -3.1797,-7.14496 -7.09715,-7.14496l-28.38947,0c-3.91745,0 -7.09716,3.20112 -7.09716,7.14496l0,42.87148c0,3.94384 3.17971,7.14497 7.09716,7.14497zm7.09716,-42.87148l14.19515,0l0,28.5807l-14.19515,0l0,-28.5807z",
    id: "svg_14",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 280.952,
    y: 263.991,
    width: 23.867,
    height: 37.862,
    id: "svg_47",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.19515,303.50678c0,3.94384 3.17971,7.14497 7.09716,7.14497l28.38947,0c3.91745,0 7.09715,-3.20113 7.09715,-7.14497l0,-42.87147c0,-3.94384 -3.1797,-7.14497 -7.09715,-7.14497l-28.38947,0c-3.91745,0 -7.09716,3.20113 -7.09716,7.14497l0,42.87147zm14.19432,-35.72567l14.19515,0l0,28.58071l-14.19515,0l0,-28.58071z",
    id: "svg_15",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 207.904,
    y: 90.699,
    width: 23.867,
    height: 37.862,
    id: "svg_50",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.31823,139.16669l28.38946,0c3.91745,0 7.09716,-3.20113 7.09716,-7.14497l0,-42.87148c0,-3.94384 -3.17971,-7.14496 -7.09716,-7.14496l-28.38946,0c-3.91746,0 -7.09716,3.20112 -7.09716,7.14496l0,42.87148c-0.00084,3.94384 3.17887,7.14497 7.09716,7.14497zm7.09715,-42.87148l14.19515,0l0,28.5807l-14.19515,0l0,-28.5807z",
    id: "svg_16",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.96054,384.17717c-1.27753,1.35732 -2.05853,3.21536 -2.05853,5.0734c0,1.85804 0.78099,3.71525 2.05853,5.0734c1.34824,1.28615 3.19385,2.0724 5.03946,2.0724c1.84561,0 3.69039,-0.78625 5.03946,-2.0724c1.27754,-1.35731 2.05853,-3.21536 2.05853,-5.0734c0,-1.85804 -0.78099,-3.71525 -2.05853,-5.0734c-2.69731,-2.6443 -7.38161,-2.6443 -10.07892,0z",
    id: "svg_17",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 208.627,
    y: 263.991,
    width: 23.867,
    height: 37.862,
    id: "svg_46",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.66673,303.50678c0,3.94384 3.17971,7.14497 7.09716,7.14497l28.3903,0c3.91745,0 7.09716,-3.20113 7.09716,-7.14497l0,-42.87147c0,-3.94384 -3.17971,-7.14497 -7.09716,-7.14497l-28.38947,0c-3.91745,0 -7.09716,3.20113 -7.09716,7.14497l0,42.87147l-0.00083,0zm14.19515,-35.72567l14.19515,0l0,28.58071l-14.19515,0l0,-28.58071z",
    id: "svg_18",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.02592,346.37826c0,3.94384 3.1797,7.14497 7.09716,7.14497l21.2923,0l0,64.30721c0,3.94384 3.17971,7.14497 7.09716,7.14497c3.91745,0 7.09716,-3.20113 7.09716,-7.14497l0,-64.30721l56.77977,0l0,64.30721c0,3.94384 3.1797,7.14497 7.09716,7.14497s7.09715,-3.20113 7.09715,-7.14497l0,-64.30721l21.29231,0c3.91745,0 7.09716,-3.20113 7.09716,-7.14497s-3.17971,-7.14497 -7.09716,-7.14497l-127.75301,0c-3.91746,0 -7.09716,3.20113 -7.09716,7.14497z",
    id: "svg_19",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.75385,303.50678c0,3.94384 3.17971,7.14497 7.09716,7.14497l28.38946,0c3.91746,0 7.09716,-3.20113 7.09716,-7.14497l0,-42.87147c0,-3.94384 -3.1797,-7.14497 -7.09716,-7.14497l-28.38946,0c-3.91746,0 -7.09716,3.20113 -7.09716,7.14497l0,42.87147zm14.19515,-35.72567l14.19515,0l0,28.58071l-14.19515,0l0,-28.58071z",
    id: "svg_20",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.26639,39.13296l-184.53278,0c-3.91745,0 -7.09716,3.20113 -7.09716,7.14497l0,371.55251c0,3.94384 3.17971,7.14497 7.09716,7.14497c3.91745,0 7.09716,-3.20113 7.09716,-7.14497l0,-364.40754l170.33846,0l0,364.40754c0,3.94384 3.17971,7.14497 7.09716,7.14497s7.09716,-3.20113 7.09716,-7.14497l0,-371.55251c0.00083,-3.94384 -3.17888,-7.14496 -7.09716,-7.14496l0,-0.00001z",
    id: "svg_21",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 94.354,
    y: 262.535,
    width: 23.867,
    height: 37.862,
    id: "svg_53",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.67043,303.50678c0,3.94384 3.17971,7.14497 7.09716,7.14497l28.3903,0c3.91745,0 7.09716,-3.20113 7.09716,-7.14497l0,-42.87147c0,-3.94384 -3.17971,-7.14497 -7.09716,-7.14497l-28.38947,0c-3.91745,0 -7.09716,3.20113 -7.09716,7.14497l0,42.87147l-0.00083,0zm14.19515,-35.72567l14.19515,0l0,28.58071l-14.19515,0l0,-28.58071z",
    id: "svg_52",
    fill: "#193351",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001Wohnung);
export default __webpack_public_path__ + "static/media/001 Wohnung.247c7f78c4664128950f5af23412f76e.svg";
export { ForwardRef as ReactComponent };